import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { IconButton, useTheme } from '@mui/material';
import { FC } from 'react';

interface WbTableRowDeleteButtonProps {
  onClick: () => void;
}

export const WbTableRowDeleteButton: FC<WbTableRowDeleteButtonProps> = ({ onClick }) => {
  const theme = useTheme();

  return (
		<IconButton
			sx={{
				'&:hover': { background: theme.colors.error.lighter },
				'color': theme.palette.error.main,
			}}
			color="inherit"
			size="small"
			onClick={onClick}>
			<DeleteTwoToneIcon fontSize="small" />
		</IconButton>
	)
};
